import { makeStyles } from "@material-ui/core";
const FTLControlsStyles = makeStyles((theme) => ({
    iconWrapper: ({ size, }) => ({
        display: "flex",
        alignItems: "center",
        marginRight: size === "small" ? -4 : 0,
    }),
    startAdornment: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        height: "100%",
        maxHeight: "none",
        padding: "6px 0",
    },
    clearIndicator: ({ size, }) => ({
        marginRight: size === "medium" ? 4 : 0,
        "& svg": {
            fill: theme.palette.icon.tertiary,
            "&:hover": {
                fill: theme.palette.icon.secondary,
            },
        },
    }),
    input: ({ readOnly }) => ({
        "& .MuiInputBase-input, & .MuiInputBase-root": {
            cursor: readOnly ? "pointer !important" : undefined,
        },
    }),
    hideInput: {
        "& .MuiInputBase-input": {
            padding: 0,
            width: 0,
            color: "transparent",
        },
    },
    loader: {
        marginRight: 4,
    },
}));
export default FTLControlsStyles;
//# sourceMappingURL=FTLSelectControlsStyles.styles.js.map